import { createTestIds } from '../../utils';

export const elements = ['button', 'dialog'] as const;

export const getInlineEditTestIds = createTestIds('inline-edit', elements);
